import { render, staticRenderFns } from "./ProjectInventoryList.vue?vue&type=template&id=193dbc52&scoped=true"
import script from "./ProjectInventoryList.vue?vue&type=script&lang=js"
export * from "./ProjectInventoryList.vue?vue&type=script&lang=js"
import style0 from "./ProjectInventoryList.vue?vue&type=style&index=0&id=193dbc52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193dbc52",
  null
  
)

export default component.exports